import React from 'react';
import { MuiBox } from 'theme/material-ui';
import { PersonalInfoInputLabel, PreRegInputBox, PersonalInfoFormControl } from './styled';
import Config from 'react-native-config';
import { KeyValue } from 'store/preRegistration/types';

const ALLOW_UPDATE = Config.PRE_REG_ALLOW_SAVE_PATIENT_DATA === 'enabled';

interface DisplayEthnicityProps {
  value: string;
  orderedEthnicities: KeyValue[];
  onChange: (event: Event) => void;
}

export function DisplayEthnicity({ value, orderedEthnicities, onChange }: DisplayEthnicityProps) {
  return (
    <MuiBox data-testid="display-ethnicity">
      <PersonalInfoInputLabel required={!!ALLOW_UPDATE}>Ethnicity</PersonalInfoInputLabel>
      <PersonalInfoFormControl>
        <PreRegInputBox
          name="ethnicity"
          disabled={!ALLOW_UPDATE}
          as={ALLOW_UPDATE ? 'select' : ''}
          value={value}
          onChange={onChange}
        >
          {orderedEthnicities.map(ethnicity => (
            <option key={ethnicity.value} value={ethnicity.value}>
              {ethnicity.key}
            </option>
          ))}
        </PreRegInputBox>
      </PersonalInfoFormControl>
    </MuiBox>
  );
}
